import React, {useState} from 'react';
import {useDynamicRuntimeFormConfig} from "@/modules/action-flow/config/hooks/use-action-flow";
import DynamicWorkflowForm from "@/modules/action-flow/runtime/components/dynamic-form/DynamicWorkflowForm";

interface ApprovalPageProps {
    currentStep: number;
    setCurrentStep: (step: number) => void;
    domain: string;
    subscriptionId: string;
    initialData: any;
    onSubmit: (values: any) => void;
    customComponents: Record<string, React.ComponentType<any>>;
    nodeId?: string;
}


const ApprovalPage: React.FC<ApprovalPageProps> = ({currentStep, setCurrentStep, domain, subscriptionId, initialData, onSubmit, customComponents, nodeId }) => {
    const { config: configJson, isLoading, isError } = useDynamicRuntimeFormConfig(domain, subscriptionId, nodeId);

    if (isLoading) return <div>Loading...</div>;
    if (isError) return <div>Error loading configuration</div>;


    // Add safety check for config structure
    if (!configJson) {
        return (
            <div className="p-4">
                <h3>Configuration Not Found</h3>
                <p>No form configuration found for this approval step.</p>
                <p><strong>Domain:</strong> {domain}</p>
                <p><strong>Subscription ID:</strong> {subscriptionId}</p>
                {nodeId && <p><strong>Node ID:</strong> {nodeId}</p>}
                <p>Please contact your administrator to set up the form configuration for this approval step.</p>
            </div>
        );
    }

    // Add safety check for steps
    // @ts-ignore`S
    if (!configJson?.steps || !Array.isArray(configJson?.steps) || configJson?.steps.length === 0) {
        return (
            <div className="p-4">
                <h3>No Form Steps Configured</h3>
                <p>The form configuration exists but has no steps defined.</p>
                <p><strong>Domain:</strong> {domain}</p>
                <p><strong>Subscription ID:</strong> {subscriptionId}</p>
                {nodeId && <p><strong>Node ID:</strong> {nodeId}</p>}
                <p>Please contact your administrator to configure the form steps for this approval.</p>
            </div>
        );
    }

    return (
        // @ts-ignore
        <DynamicWorkflowForm currentStep={currentStep} setCurrentStep={setCurrentStep}  config={configJson} initialData={initialData} onSubmit={onSubmit} customComponents={customComponents} />
    );
};

export default ApprovalPage;